import React from "react";

const productKeys = [
    { "RRPPrice": "RRP Price" },
    { "DefaultPrice": "Regular Price" },
    { "BeautyManiaDefaultPrice": "BeautyMania DefaultPrice" },
    { "P1": "P1" },
    { "LCost": "Landing Cost" },
    { "KoganDefaultPrice": "Kogan DefaultPrice" },
    { "MyDealPrice": "MyDeal Price" },

    { "Size": "Size" },
    { "Weight": "Weight" },
    { "Width": "Width" },
    { "Length": "Length" },
    { "Height": "Height" },
    { "Cubic": "Cubic" },
    // { "SOH": "SOH" },
    { "countryofOrigin": "Country of Origin" },
        { "ProductCategories": "Product Categories" },
    { "ProductTags": "Product Tags" },

    { "AZDC": "Amazon DC" },
    { "AZDF": "Amazon DF" },
    { "KoganEDI": "Kogan EDI" },
      // { "WebEnabled": "Web Enabled" },
      { "Revlon": "Revlon" },
      // { "Barcode": "Barcode" },
      { "WHS": "WHS" },
      { "MyDeal": "MyDeal" },
    // { "WeeklyOffer": "Weekly Offer" },
    { "EDLP": "EDLP" },

    { "LongDescription": "Long Description" },
    { "MyDealCategory": "MyDeal Category" },
    { "KoganCategory": "Kogan Category" },
];

export default productKeys;
